import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import FoodBev from '../components/Inventory/FoodBev';
import LowStockBanner from '../features/inventory/LowStockBanner';
import PageHeader from '../components/layout/PageHeader';

export default function RawIngredients({ reload }) {
  const location = useLocation();
  const navigate = useNavigate();
  const focusLowStock = Boolean(location.state?.focusLowStock);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
      <PageHeader
        title="Raw ingredients"
        subtitle="Production inputs, packaging, and stock on hand"
      />
      <LowStockBanner
        onView={() => navigate('/inventory/raw-ingredients', { state: { focusLowStock: true }, replace: true })}
      />
      <Box sx={{ flex: 1, px: { xs: 1, md: 2 }, pt: 1.5, pb: 3 }}>
        <FoodBev
          key={focusLowStock ? 'low-stock' : 'all'}
          reload={reload}
          pageTab="FrontOfHouse"
          focusLowStock={focusLowStock}
        />
      </Box>
    </Box>
  );
}
